import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import ProductTileVisual from '@stone/components/product/ProductTileVisual';
import ProductTile from './ProductTile';
import ProductImage from '@stone/components/product/ProductImage';
import classNames from 'classnames';
import useBreakpoint from '@common/utils/useBreakpoint';
import customEventBus from '@common/scripts/libs/eventBus';
import { SM, MD, LG, HIRES } from '@utils/imageutils';
const ProductShopTheLookModule = (props) => {
    const { product, looks } = props;
    const { t } = useTranslation();
    const [activeProduct, setActiveProduct] = useState(0);
    const currentBreakpoint = useBreakpoint();
    const smBreakpoint = parseInt(window.mqObj.sm.toString());
    const lgBreakpoint = parseInt(window.mqObj.lg.toString());
    const xxlBreakpoint = parseInt(window.mqObj.xxl.toString());
    const formattedCurrentNumber = (activeProduct + 1).toString().padStart(2, '0');
    const formattedTotalNumber = looks === null || looks === void 0 ? void 0 : looks.length.toString().padStart(2, '0');
    const onTileClickMobile = (lookIndex) => {
        customEventBus.emit('shopthelook:quickbuy', { lookIndex: lookIndex, fromMainModule: true });
    };
    const progressionLabel = useMemo(() => {
        if (!looks || looks.length === 0) {
            return '';
        }
        else if (looks.length === 1) {
            return formattedCurrentNumber;
        }
        else if (looks.length > 1) {
            return `${formattedCurrentNumber}/${formattedTotalNumber}`;
        }
    }, [activeProduct, looks]);
    const ariaLabelProgression = useMemo(() => {
        if (!looks || looks.length === 0) {
            return '';
        }
        else if (looks.length === 1) {
            return `${t('label.item')} ${formattedCurrentNumber} : ${looks[activeProduct].productName}`;
        }
        else if (looks.length > 1) {
            return `${t('shopthelook.carouselelements', { 0: formattedCurrentNumber, 1: formattedTotalNumber })} : ${looks[activeProduct].productName}`;
        }
    }, [activeProduct, looks]);
    const renderProductImage = (look) => {
        return React.createElement(ProductImage, { img: look === null || look === void 0 ? void 0 : look.imgs, type: "F" });
    };
    const renderProductTile = (look, i) => {
        return React.createElement(ProductTile, { inShopTheLookModule: true, product: look, onShopTheLookClick: currentBreakpoint < xxlBreakpoint && (() => onTileClickMobile(i)) });
    };
    //* SECTION - RENDER --------------------------------------------------------------------
    if (looks.length <= 0) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(Tabs, { className: "shopthelookmodule tabs", onSelect: (i, last, event) => {
            if (currentBreakpoint < lgBreakpoint) {
                const target = event.target;
                window.scrollBy({
                    top: target.getBoundingClientRect().y,
                    left: 0,
                    behavior: 'smooth',
                });
            }
            setActiveProduct(i);
        } },
        React.createElement("div", { className: "shopthelookmodule-hero" },
            React.createElement("div", { className: "shopthelookmodule-title" },
                React.createElement("h3", { className: "shopthelook-title font__title" }, t('label.shopthelook')),
                React.createElement("span", { className: "shopthelook-title font__title" },
                    formattedTotalNumber,
                    " ",
                    t('label.items'))),
            React.createElement(ProductTileVisual, { product: product, inGallery: true, visual1: product.lookMainAsset || 'R', visual2: '', sizes: [SM, MD, LG, HIRES] }),
            looks.length > 1 && (React.createElement(TabList, { className: classNames(['react-tabs__tab-list no-divider shopthelookmodule-thumbs', { long: looks.length > 4 }]), "aria-orientation": currentBreakpoint > smBreakpoint ? 'vertical' : 'horizontal' }, looks.map((look) => (React.createElement(Tab, { key: look.uuid, className: "shopthelookmodule-tab" }, renderProductImage(look))))))),
        React.createElement("div", { className: "shopthelookmodule-closeup" },
            React.createElement("div", { className: "shopthelookmodule-title" },
                React.createElement("div", { className: "shopthelook-title left font__title", "aria-hidden": true }, t('label.item')),
                React.createElement("div", { className: "shopthelook-title right font__title", "aria-label": ariaLabelProgression }, progressionLabel)),
            looks.length > 1 ? looks.map((look, i) => React.createElement(TabPanel, { key: look.uuid }, renderProductTile(look, i))) : renderProductTile(looks[0], 0))));
};
export default ProductShopTheLookModule;
